export default "__VITE_ASSET__612a6d22__"